import { render } from "./ProductItemList_IP.vue?vue&type=template&id=4d43928f&ts=true"
import script from "./ProductItemList_IP.vue?vue&type=script&lang=ts"
export * from "./ProductItemList_IP.vue?vue&type=script&lang=ts"

import "./ProductItemList_IP.vue?vue&type=style&index=0&id=4d43928f&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__